// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

	document.addEventListener('DOMContentLoaded', () => {
		document.querySelectorAll(".btn").forEach(btn => {
			let btnText = btn.textContent;
			btn.innerHTML = `<span>${btnText}</span>`;
		});
	});

	// Form Header Functionality
	if(document.getElementById("header-form")){
		let formContent = document.getElementById("header-form");
		let openFormBtn = document.querySelector("[data-open_form]");
		let closeFormBtn = document.querySelector("[data-close_form]");
		// Show
		openFormBtn.addEventListener('click', function (e) {
			e.preventDefault();
			formContent.classList.add("open");
		});
		// Close
		closeFormBtn.addEventListener('click', function (e) {
			e.preventDefault();
			formContent.classList.remove("open");
		});
	}

	// Mobile Menu Functionality
	if(document.getElementById("navMenuBar")){
		let mobileContent = document.getElementById("navContainer");
		let navMobile = document.getElementById("navMenuBar");
		let menuBtn = document.querySelector("#navMenuBar [data-show_nav_m]");
		let closeBtn = document.querySelector("#navContainer [data-close_nav_m]");
		// Show
		menuBtn.addEventListener('click', function (e) {
			mobileContent.classList.add("open");
			navMobile.classList.add("menuOpen");
			document.querySelector("body").classList.add("no-scroll");
		});
		// Close
		closeBtn.addEventListener('click', function (e) {
			mobileContent.classList.remove("open");
			navMobile.classList.remove("menuOpen");
			document.querySelector("body").classList.remove("no-scroll");
		});
	}

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

	let swiperGallery = document.querySelectorAll('.gallery-block');
    if(swiperGallery){
        swiperGallery.forEach((item)=>{
			new Swiper('.gallery-block__swiper', {
                /*Optional parameters*/
                loop: true,
				speed: 700,
				slidesPerView: 1.2,
				spaceBetween: 20,
				centeredSlides: true,
				
				breakpoints: {
					// when window width is >= 480px
					480: {
						slidesPerView: 4,
						spaceBetween: 22,
						centeredSlides: false,
					},
				},
            });
        });
    };

	let swiperReviews = document.querySelectorAll('.reviews-block');
    if(swiperReviews){
        swiperReviews.forEach((item)=>{
			new Swiper('.swiper-reviews', {
                /*Optional parameters*/
                loop: true,
				speed: 700,
				effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false
                },
				pagination: {
					el: ".reviews-pagination",
					clickable: true
				}
            });
        });
    };
	
	let swiperSlider = document.querySelectorAll('.slider-block');
    if(swiperSlider){
		swiperSlider.forEach((item)=>{
			const slideID = item.getAttribute("id");
	
            var swiperImages = new Swiper(`#${slideID} .slider-block__images`, {
                /*Optional parameters*/
                loop: true,
				effect: "fade",
				speed: 400,
				slidesPerView: 1,
				creativeEffect: {
					prev: {
					  shadow: true,
					  translate: ["-20%", 0, -1],
					},
					next: {
					  translate: ["100%", 0, 0],
					},
				},
				allowTouchMove: false
            });
			var swiperText = new Swiper(`#${slideID} .slider-block__text`, {
                /*Optional parameters*/
                loop: true,
				effect: "fade",
				speed: 400,
				autoHeight: false,
                fadeEffect: {
                    "crossFade": true
                },
				controlled: true,
				controller:{
					control: swiperImages,
				},
				navigation: {
					nextEl: `#${slideID} .swiper-button-next`,
					prevEl: `#${slideID} .swiper-button-prev`,
				},
				allowTouchMove: true,
				// Responsive breakpoints
				breakpoints: {
					// when window width is >= 480px
					480: {
						allowTouchMove: false,
					},
				},
            });
        });
    };

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}